import {
  HomeNextConversationResponse,
  HomeTodoDto,
} from "@coaching-culture/types";
import axios from "axios";
import { useQuery, useQueryClient } from "react-query";

export const getHomeTodos = () =>
  axios.get<HomeTodoDto[]>("/api/v2/home/todos").then(({ data }) => data);

export const getNextConversation = () =>
  axios
    .get<HomeNextConversationResponse>("/api/v2/home/next-conversation")
    .then(({ data }) => data.next);

/**
 * Everything the signed-in user has to do, from every enabled product.
 * Refetches when the window regains focus, so finishing something in
 * another tab shows up on return.
 */
export const useHomeTodos = () =>
  useQuery(["home", "todos"], getHomeTodos, {
    refetchOnWindowFocus: true,
  });

/** The signed-in user's next conversation and what changed since the last one. */
export const useNextConversation = (enabled = true) =>
  useQuery(["home", "next-conversation"], getNextConversation, {
    refetchOnWindowFocus: true,
    enabled,
  });

/** Call after any change that could add or remove a Home to-do. */
export const useInvalidateHome = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries(["home"]);
};
